// @ts-strict-ignore
import clsx from 'clsx'
import { FC, useState } from 'react'
import { createPortal } from 'react-dom'

import Flex from '@/shared/ui/Flex'
import { Margin } from '@/shared/ui/margin'
import { Title } from '@/shared/ui/Typography'

import { TotalProductItem } from '../TotalProductItem/TotalProductItem'
import { TotalProductInfoProps } from '../TotalProductSetItem'

import cl from './total-drawer-content.module.scss'

/**
 * Component for displaying a list of active services and accessories in the product card.
 * Displayed for mobile and tablet version.
 *
 * @param props
 * @param props.relatedItems - list of accessories and services
 * @param props.totalText - Text with a summary of active products
 * @param props.formattedPrice
 * @param props.onDeleteClick
 *
 * */
export const TotalDrawerContent: FC<TotalProductInfoProps> = ({
	relatedItems,
	formattedPrice,
	totalText,
	onDeleteClick
}) => {
	const [visible, setVisible] = useState(false)

	return (
		<>
			{createPortal(
				<>
					<article className={clsx(cl.totalDrawerContent, visible && cl[`totalDrawerContent--visible`])}>
						<Margin mb="3x">
							<Flex justifybetween>
								<Title level="3">Добавленные услуги</Title>
								<button className={cl.totalDrawerContent__closeButton} onClick={() => setVisible(false)}>
									Закрыть
								</button>
							</Flex>
						</Margin>
						{relatedItems.map(item => (
							<TotalProductItem {...item} key={item.ID} onClick={onDeleteClick} />
						))}
					</article>
					{visible && <div className={cl[`totalDrawerContent--overlay`]} onClick={() => setVisible(false)} />}
				</>,
				document.body
			)}
			<button className={cl.totalDrawerContent__button} onClick={() => setVisible(true)}>
				{totalText}&thinsp;
			</button>
			на {formattedPrice}
		</>
	)
}
